<template>
  <span v-if="link" class="clickable-id" @click="navigate">
    {{ value }}
  </span>
  <span v-else>
    {{ value }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value: string) => ['driver', 'trip', 'vehicle', 'plate'].includes(value),
  },
  value: {
    type: String,
    required: true,
  },
})

const router = useRouter()

const link = computed(() => {
  switch (props.type) {
    case 'driver':
      return { name: 'driversingle', params: { carNumber: props.value } }
    case 'trip':
      return { name: 'tripsingle', params: { tripId: props.value } }
    case 'vehicle':
    case 'plate':
      return { name: 'vehiclesingle', params: { carNumber: props.value } }
    default:
      return null
  }
})

function navigate() {
  if (link.value) {
    const route = router.resolve(link.value)
    window.location.href = route.href
  }
}
</script>

<style scoped>
.clickable-id {
  color: var(--va-primary);
  text-decoration: none;
  cursor: pointer;
}
.clickable-id:hover {
  text-decoration: underline;
}
</style>
